import React from 'react'
import { Link } from 'react-router';

var ClientServiceStore = require('../../stores/ClientServiceStore');
var ButtonLink = require('react-router-bootstrap').ButtonLink;

var OutdatedRow = React.createClass({
  propTypes: {
    serviceId: React.PropTypes.number.isRequired
  },

  componentDidMount() {
    ClientServiceStore.addChangeListener(this.update);

    this.update()
  },

  componentWillReceiveProps() {
    this.update();
  },

  componentWillUnmount: function () {
    ClientServiceStore.removeChangeListener(this.update);
  },

  getInitialState() {
    return {
      service: null,
    }
  },

  update() {
    this.setState({
      service: ClientServiceStore.getService(this.props.serviceId)
    })
  },

  render: function () {
    if (!this.state.service) {
      return <tr />
    }

    const service = this.state.service

    return (
      <tr>
        <td>
            <h5>{service.service_display_name}</h5>
            {this.state.service.site.name}
        </td>
        <td>
            <Link to="service" params={{serviceId: this.state.service.id}}>
                <i className="fa fa-search" title="View Service"></i>{' '}
                {this.state.service.identifier}
            </Link>
        </td>
        <td>
          <ButtonLink to="service-upgrade" bsSize="sm" bsStyle="warning" className="pull-right" params={{ serviceId: service.id }}>Upgrade</ButtonLink>
        </td>
      </tr>
    );
  },
})
module.exports = OutdatedRow;



// WEBPACK FOOTER //
// ./app/components/ClientService/OutdatedRow.js